export const MEDIA_SEND_HEADER_FETCH_ALL = 'MEDIA_SEND_HEADER_FETCH_ALL'
export const MEDIA_SEND_HEADER_CREATE = 'MEDIA_SEND_HEADER_CREATE'
export const MEDIA_SEND_HEADER_UPDATE = 'MEDIA_SEND_HEADER_UPDATE'
export const MEDIA_SEND_HEADER_REMOVE = 'MEDIA_SEND_HEADER_REMOVE'

export const MEDIA_BUE_FETCH_ALL = 'MEDIA_BUE_FETCH_ALL'
export const MEDIA_BUE_CREATE = 'MEDIA_BUE_CREATE'
